import { render, staticRenderFns } from "./PortalAR.vue?vue&type=template&id=8d373740&"
import script from "./PortalAR.vue?vue&type=script&lang=js&"
export * from "./PortalAR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports